import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/home/game_arrow_white.png'


const _hoisted_1 = { class: "message_container" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = {
  key: 2,
  class: "no_more"
}

import { ref } from 'vue'
import MessageCard from './components/messageCard.vue';
import CustomHeader from '../components/common/customHeader.vue';
import NoData from '../components/common/noData.vue';
import { MessageData, TAB_LIST } from '@/view/message/supportScript';


export default /*@__PURE__*/_defineComponent({
  __name: 'messageView',
  props: {
    dataSet: {}
  },
  emits: ['onClickTab', 'getNextPageMsgList'],
  setup(__props: any, { emit: __emit }) {

const active = ref(0)
const props = __props
const emits = __emit

const setNoticeTypeName = (type: number, activityName : string) => {
    const tab = props.dataSet?.tabList.find(item => item.notice_type === type)
    if(!type){
        return props.dataSet?.activeTab?.name || ''
    }
    if(type == 4){
     return activityName ? activityName : 'message.bonus'
    }else{
        return tab ? tab.name : ''
    }
}
const onClickTab = (value: any) => {
    emits('onClickTab', value)
}

const getNextPageMsgList = () => {
    emits('getNextPageMsgList')
}

return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!
  const _component_van_tab = _resolveComponent("van-tab")!
  const _component_van_tabs = _resolveComponent("van-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(CustomHeader, {
      text: _ctx.$t('message.message')
    }, null, 8, ["text"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_van_tabs, {
        active: active.value,
        "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((active).value = $event)),
        sticky: "",
        ellipsis: false,
        onClickTab: onClickTab
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSet?.tabList, (item, index) => {
            return (_openBlock(), _createBlock(_component_van_tab, {
              key: index,
              title: _ctx.$t(item.name),
              name: index
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSet?.noticeList, (item) => {
                    return (_openBlock(), _createBlock(MessageCard, {
                      key: item.id,
                      messageData: item,
                      title: setNoticeTypeName(item.type, item.activityName),
                      attachement: item.attachment
                    }, null, 8, ["messageData", "title", "attachement"]))
                  }), 128)),
                  (_ctx.dataSet?.noticeList.length == 0)
                    ? (_openBlock(), _createBlock(NoData, { key: 0 }))
                    : (_ctx.dataSet?.totalMsg > _ctx.dataSet?.pageSize * _ctx.dataSet?.pageNo)
                      ? (_openBlock(), _createBlock(_component_van_row, { key: 1 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_van_col, {
                              span: "24",
                              class: "arrowDown"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("img", {
                                  src: _imports_0,
                                  alt: "",
                                  onClick: getNextPageMsgList
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.$t('message.noMore')), 1))
                ])
              ]),
              _: 2
            }, 1032, ["title", "name"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["active"])
    ])
  ]))
}
}

})